import {
  ComponentRef,
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject
} from '@angular/core';
import { ErrorComponent } from '../components/api-call-components/error/error.component';
import { LoadingComponent } from '../components/api-call-components/loading/loading.component';
import { ApiSignal } from '../util/api-signal';
import { LoadingIndicatorDirectiveBase } from './loading-indicator-base';

/**
 * A structural directive which will wrap the element and place a centered sd-spinner as a sibling.
 * {@inheritDoc ApiCallDirectiveBase}
 */
@Directive({
  selector: '[wctLoadingIndicatorWrapper], [wctApiCall]',
  standalone: true,
})
export class LoadingIdicatorWrapperDirective extends LoadingIndicatorDirectiveBase {
  /** The source for displayed errors and data. If the signal holds `undefined` the spinner will be visible. */
  @Input({ required: false }) public set wctApiCall(value: ApiSignal<unknown> | undefined) {
    this.apiSignal = value;
  }

  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainerRef: ViewContainerRef = inject(ViewContainerRef);

  constructor() {
    super();
    this.placeRegular();
  }

  protected override placeRegular(): void {
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }

  protected override placeError(error: Error): void {
    if (!this.apiCallDisplayErrorElement) {
      this.placeRegular();
      return;
    }

    const component: ComponentRef<ErrorComponent> = this.viewContainerRef.createComponent(ErrorComponent);
    component.instance.error = this.apiCallErrorMsg || error;
    component.instance.template = this.templateRef;
  }

  protected override placeLoading(): void {
    const component: ComponentRef<LoadingComponent> = this.viewContainerRef.createComponent(LoadingComponent);
    component.instance.template = this.templateRef;
  }

  protected override clear(): void {
    this.viewContainerRef.clear();
  }
}
